import {Brand} from "../../types/Brand";
import "./snippet.component";
import {renderSnippet} from "./snippet";
import '../../lamudi/loader.component';
import {getDetail, getListings} from "../../webcomponents/serpmap/v1/listings.api";
import {Serpmap} from "../../webcomponents/serpmap/v1/serpmap";
import "../../webcomponents/serpmap/v1/serpmap";

export function initMap() {
    let map = document.querySelector<Serpmap>('#js_serp-map');
    if (!map) {
        return
    }
    map.getPoints = getListings(Brand.LAMUDI)
    map.getDetail = (listingId: string) => getDetail(listingId, Brand.LAMUDI)
    map.renderSnippet = renderSnippet
    map.renderLoading = () => `<lamudi-loader></lamudi-loader>`
    document.querySelectorAll<HTMLElement>('.js_open-map').forEach((element) => element.onclick = () => {
        document.body.classList.add('with-map');
        map.show()
    });
    document.querySelectorAll<HTMLElement>('.js_close-map').forEach((element) => element.onclick = () => {
        document.body.classList.remove('with-map');
    });
}

window.addEventListener("load", () => initMap());